<template>
  <div class="col-sm-12 nopads">
    <div class="col-sm-12 editor-form" @click.stop="">
        <h2 class="editor-header">{{ (materialTypeUpdate.id > 0) ? $t('materials.edit_type') : $t('materials.add_type') }}</h2>
          <div class="col-sm-12 form-data nopads">
            <span class="span-title">
              {{ $t('materials.name') }}
            </span>
            <input
                  id="name"
                  v-model="materialTypeUpdate.name"
                  type="text"
                  class="form-control form-control-sm"
            />
            <div class="col-sm-12 button-container">
              <button class="btn btn-secondary form-button" @click.stop="$emit('close')">
                  {{ $t('common.cancel') }}
              </button>
              <button class="btn btn-success form-button" :disabled="loading" @click.stop="submit">
                  {{ $t('common.save') }}
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="loading"
          id="loader"
          class="spinner"
        />
  </div>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import {inject} from "vue";

export default {
    name: "MaterialTypeEditor",
    mixins: [restApi],
    props: {
        materialType: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            materialTypeUpdate: this.jsonToItem(this.materialType)
        }
    },
    methods: {
        setDefaultValues: function (data) {
            if (data.name === '') {
                this.showAlert(this.$t('inspectable_editor.invalid_name'))
                return undefined
            }
            return data
        },
        submit: function () {
            let json = this.setDefaultValues(this.materialTypeUpdate)
            if (json !== undefined) {
                this.loading = true
                if (this.materialTypeUpdate.id < 1) {
                    this.restAdd(this.materialTypeUrl, json, this.success, this.fail)
                } else {
                    this.restUpdate(this.materialTypeUrl, json, this.success, this.fail)
                }
            }
        },
        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },
        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },
        jsonToItem: function (item) {
            return JSON.parse(JSON.stringify(item))
        }
    }
}
</script>
